<template>
  <div class="map">
    <div id="txMap" class="txMap">
      <el-select class="provinceSelect" v-model="provinceValue" filterable clearable size="small" placeholder="省份" @change="changeProvince">
        <el-option v-for="item in provinceList" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-select class="villageSelect" v-model="villageValue" filterable clearable size="small" placeholder="小区名称">
        <el-option v-for="item in villageList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
      </el-select>
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <el-collapse class="dataCount">
        <el-collapse-item title="数据统计">
          <div class="dataDiv">
            <div class="villageImage"></div>
            <div class="dataContent">
              <div class="dataNumber">{{ villageTotal }}</div>
              <div class="dataTitle">使用小区(个)</div>
            </div>
          </div>
          <div class="dataDiv">
            <div class="liftImage"></div>
            <div class="dataContent">
              <div class="dataNumber">{{ liftTotal }}</div>
              <div class="dataTitle">监控电梯(部)</div>
            </div>
          </div>
          <!-- <div class="dataDiv">
            <div class="userImage"></div>
            <div class="dataContent">
              <div class="dataNumber">1687909</div>
              <div class="dataTitle">注册人数(人)</div>
            </div>
          </div> -->
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Map',
  data () {
    return {
      map: null, // 地图对象
      mapMarkers: null, // 地图聚合点
      mapMarker: null, // 地图标记点
      beforeMarker: null, // 地图点击的上一个标记点
      info: null, // 地图信息框
      mapMarkerArr: [], // 地图标记点数组
      provinceValue: '', // 省份下拉菜单选中value
      provinceList: [], // 省份下拉菜单
      villageValue: '', // 小区名称下拉菜单选中value
      villageList: [], // 小区名称下拉菜单
      villageTotal: 0, // 小区总数
      liftTotal: 0 // 电梯总数
    }
  },
  mounted () {
    // 获取有效省份列表
    this.$http.get(this.$api.map_province_list).then((res) => {
      let data = res.data

      if (data.success) {
        this.provinceList = data.data
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    // 获取小区列表
    this.$http.get(this.$api.village_list, {
      params: {
        pageSize: 9999,
        pageNum: 1
      }
    }).then((res) => {
      let data = res.data

      if (data.success) {
        this.villageList = data.data.list
        // 腾讯地图初始化
        this.mapInit()
      } else {
        this.$message({
          type: 'error',
          message: data.msg,
          duration: 1000
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    // 获取小区、电梯总数
    this.getCountNumber()
  },
  methods: {
    mapInit () {
      this.map = new window.qq.maps.Map(document.getElementById('txMap'), {
        center: new window.qq.maps.LatLng(39.916527, 116.397128), // 地图中心
        zoom: 5, // 地图缩放级别
        disableDefaultUI: true // 禁止所有控件
      })
      // 信息框初始化
      this.info = new window.qq.maps.InfoWindow({
        map: this.map
      })
      // 标记点数组
      this.mapMarkerArr = new window.qq.maps.MVCArray()
      // 标记点初始化
      this.myMarker()
      // 聚合点初始化
      this.myMarkers()
    },
    myMarker () {
      let icon = new window.qq.maps.MarkerImage(require('./address_blue.png'))

      for (let i = 0; i < this.villageList.length; i++) {
        this.mapMarker = new window.qq.maps.Marker({
          icon: icon,
          map: this.map,
          position: new window.qq.maps.LatLng(this.villageList[i].latitude, this.villageList[i].longitude),
          decoration: new window.qq.maps.MarkerDecoration(this.villageList[i].id, new window.qq.maps.Point(100, 100))
        })
        window.qq.maps.event.addListener(this.mapMarker, 'click', (event) => {
          let str = ''
          this.$http.get(this.$api.village_detail, {
            params: {
              id: event.target.decoration.content
            }
          }).then((res) => {
            let data = res.data

            if (data.success) {
              str += '<div class="infoWrap">' +
                        '<div class="infoHeader" title="' + data.data.data.orgdepartment.orgName + '">' + data.data.data.orgdepartment.orgName + '</div>' +
                        '<div class="infoDiv">' +
                          '<span class="infoTitle">地址：</span>' +
                          '<span class="infoContent">' + data.data.data.orgdepartment.address + '</span>' +
                        '</div>' +
                        '<div class="infoDiv">' +
                          '<span class="infoTitle">联系人：</span>' +
                          '<span class="infoContent">' + data.data.data.manager.name + '</span>' +
                        '</div>' +
                        '<div class="infoDiv">' +
                          '<span class="infoTitle">联系方式：</span>' +
                          '<span class="infoContent">' + data.data.data.manager.phone + '</span>' +
                        '</div>' +
                        '<div class="infoDiv">' +
                          '<span class="infoTitle">电梯数：</span>' +
                          '<span class="infoContent">' + data.data.data.count + ' 部</span>' +
                        '</div>' +
                      '</div>'

              if (this.beforeMarker !== null) {
                this.beforeMarker.setIcon(new window.qq.maps.MarkerImage(require('./address_blue.png')))
              }
              event.target.setIcon(new window.qq.maps.MarkerImage(require('./address_red.png')))
              this.beforeMarker = event.target
              this.info.open()
              this.info.setContent(str)
              this.info.setPosition(event.latLng)
            } else {
              this.$message({
                type: 'error',
                message: data.msg,
                duration: 1000
              })
            }
          }).catch((err) => {
            console.log(err)
          })
        })
        window.qq.maps.event.addListener(this.info, 'closeclick', () => {
          this.beforeMarker.setIcon(new window.qq.maps.MarkerImage(require('./address_blue.png')))
        })
        this.mapMarkerArr.push(this.mapMarker)
      }
    },
    myMarkers () {
      this.mapMarkers = new window.qq.maps.MarkerCluster({
        map: this.map,
        minimumClusterSize: 2,
        averageCenter: true,
        gridSize: 40,
        markers: this.mapMarkerArr
      })
    },
    search () {
      this.getCountNumber()
      this.info.close()
      if (this.villageValue === '') {
        this.map.setZoom(5)
      } else {
        this.$http.get(this.$api.village_detail, {
          params: {
            id: this.villageValue
          }
        }).then((res) => {
          let data = res.data

          if (data.success) {
            this.map.setZoom(16)
            this.map.panTo(new window.qq.maps.LatLng(Number(data.data.data.orgdepartment.latitude), Number(data.data.data.orgdepartment.longitude)))
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
              duration: 1000
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
      this.mapMarkers.clearMarkers()
      this.mapMarkerArr.length = 0
      this.myMarker()
    },
    getVillageList () {
      this.$http.get(this.$api.village_list, {
        params: {
          pageSize: 9999,
          pageNum: 1,
          province: this.provinceValue
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.villageList = data.data.list
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getCountNumber () {
      this.$http.get(this.$api.map_province_count, {
        params: {
          province: this.provinceValue
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.villageTotal = data.data.dep
          this.liftTotal = data.data.liftbase
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    changeProvince () {
      this.villageValue = ''
      this.getVillageList()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.map
  box-sizing border-box
  padding-top 60px
  width 100%
  height 100vh
  .txMap
    position relative
    width 100%
    height 100%
    .provinceSelect
      position absolute
      top 20px
      left 20px
      width 100px
      z-index 100
    .villageSelect
      position absolute
      top 20px
      left 140px
      width 160px
      z-index 100
    .searchBtn
      position absolute
      top 20px
      left 320px
      padding 5.5px 6px
      font-size 18px
      z-index 100
    .dataCount
      position absolute
      top 20px
      right 20px
      border none
      border-radius 4px
      box-shadow 0 0 10px 0 rgba(0, 0, 0, .15)
      z-index 100
      .el-collapse-item__header
        padding 0 16px
        font-weight bold
        color #333
        border none
        border-radius 4px
        &.is-active
          border-bottom-left-radius 0
          border-bottom-right-radius 0
        .el-collapse-item__arrow
          float right
          margin-right 0
      .el-collapse-item__wrap
        border none
        border-bottom-left-radius 4px
        border-bottom-right-radius 4px
      .el-collapse-item__content
        padding-bottom 16px
        border-radius 4px
      .dataDiv
        box-sizing border-box
        padding-left 8px
        width 200px
        height 80px
        .villageImage
          float left
          margin-top 12px
          margin-right 24px
          width 56px
          height 56px
          background-image url('../../assets/img/village_color.png')
          background-repeat no-repeat
          background-size 100% 100%
        .liftImage
          float left
          margin-top 12px
          margin-right 24px
          width 56px
          height 56px
          background-image url('../../assets/img/lift_color.png')
          background-repeat no-repeat
          background-size 100% 100%
        .userImage
          float left
          margin-top 12px
          margin-right 24px
          width 56px
          height 56px
          background-image url('../../assets/img/user_color.png')
          background-repeat no-repeat
          background-size 100% 100%
        .dataContent
          float left
          margin-top 20px
          .dataNumber
            line-height 24px
            font-size 20px
            font-weight bold
            color #333
          .dataTitle
            line-height 16px
            font-size 12px
            color #666
    .infoWrap
      position relative
      padding 16px 0
      width 180px
      .infoHeader
        position absolute
        top -5px
        left 0
        right 0
        line-height 22px
        font-size 14px
        color #60ACFC
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
      .infoDiv
        margin-top 8px
        line-height 18px
        font-size 14px
        .infoTitle
          display inline-block
          color #666
          vertical-align top
        .infoContent
          display inline-block
          max-width 130px
          color #333
          vertical-align top
          word-wrap break-word
          word-break break-all
</style>



// WEBPACK FOOTER //
// src/components/map/map.vue